import { firebaseConfig } from "../firebase";

// Allow a deployment-specific GA4 property while using the Firebase-linked
// Analytics property by default.
export const TRACKING_ID = (
	process.env.REACT_APP_GA_MEASUREMENT_ID || firebaseConfig.measurementId || ""
).trim();
